// controllers/toast_controller.js
import { Controller } from "@hotwired/stimulus";
import $ from "jquery";

export default class extends Controller {
  flash({ detail: { content } }) {
    if (typeof $ === "undefined" || !$.fn.toast) {
      console.warn("Fomantic-UI Toast is not available")
      return
    }

    $('body').toast({
      message: `${content}`,
      class: "success",
      displayTime: 3000,
      position: "top right"
    })
  }
}
